import React from 'react';

/**
 * PiPrinterSolid icon from the solid style in devices category.
 */
interface PiPrinterSolidProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
  className?: string;
  ariaLabel?: string;
}

export default function PiPrinterSolid({
  size = 24,
  color,
  className,
  ariaLabel = 'printer icon',
  ...props
}: PiPrinterSolidProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      
       style={{color: color || "currentColor"}}
      
      role="img"
      aria-label={ariaLabel}
      {...props}
    >
      <path fillRule="evenodd" d="M14.64 1H9.36c-.48 0-.898 0-1.244.027-.366.029-.73.092-1.087.26a3 3 0 0 0-1.29 1.168c-.204.338-.303.694-.368 1.057-.061.34-.103.756-.15 1.234l-.037.367c-.526.075-1.005.203-1.454.432A5 5 0 0 0 1.545 7.73c-.302.592-.428 1.233-.487 1.961C1 10.4 1 11.273 1 12.357v.884c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.486.247 1.027.353 1.644.399-.108.38-.2.718-.255 1.01-.071.37-.11.784.01 1.21a2.5 2.5 0 0 0 1.089 1.442c.376.233.784.31 1.16.343.36.032.804.032 1.308.032h7.72c.504 0 .947 0 1.308-.032.376-.034.784-.11 1.16-.343a2.5 2.5 0 0 0 1.088-1.443c.121-.425.082-.838.011-1.21-.055-.291-.147-.63-.255-1.01.617-.045 1.158-.15 1.644-.398a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-.885c0-1.084 0-1.958-.058-2.666-.06-.728-.185-1.369-.487-1.961a5 5 0 0 0-2.185-2.185c-.45-.229-.928-.357-1.454-.432l-.036-.367c-.048-.478-.09-.893-.151-1.234-.065-.363-.164-.719-.367-1.057a3 3 0 0 0-1.29-1.168c-.357-.168-.722-.231-1.088-.26C15.538 1 15.12 1 14.64 1ZM8.374 5q-.63 0-1.17.003l.003-.022c.052-.524.087-.86.133-1.116.043-.243.085-.334.113-.38a1 1 0 0 1 .43-.39c.049-.022.143-.055.39-.074C8.53 3 8.868 3 9.395 3h5.208c.527 0 .865 0 1.124.02.246.02.34.053.39.076a1 1 0 0 1 .43.389c.027.046.069.137.113.38.045.255.08.592.132 1.116l.002.022Q16.257 5 15.625 5zM8.13 16.074c.138-.056.329-.074 1.284-.074h5.172c.955 0 1.146.018 1.284.074.16.066.3.172.408.308.091.117.161.296.424 1.214l.462 1.62c.154.537.25.876.299 1.133.04.206.031.277.03.288a.5.5 0 0 1-.217.287c-.01.005-.077.033-.286.052-.26.023-.613.024-1.172.024H8.182c-.559 0-.911 0-1.172-.024-.208-.019-.275-.046-.285-.051a.5.5 0 0 1-.217-.288c-.002-.01-.01-.083.029-.288.05-.257.145-.596.299-1.134l.462-1.62c.263-.917.333-1.096.424-1.213.107-.136.248-.242.408-.308ZM13 10a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H14a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H18a1 1 0 0 1-1-1Z" clipRule="evenodd" fill="currentColor"/>
    </svg>
  );
}
